export const getSmartlinkSiteTraitsUrl = (siteId: string) =>
	`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
